















import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import { Prop } from 'vue-property-decorator'
import AdminCreateTicketDialog from '@/modules/ticket/components/admin/AdminCreateTicketDialog.vue'
import { TicketStoreRequestModelInAdmin } from '@/modules/ticket/models/ticket-request.model'
import { TicketPresetModel, TicketStatus } from '@/modules/ticket/models/ticket-resource.model'
import { TicketCreateUseCase } from '@/modules/ticket/use-cases/admin/ticket-create.use-case'
import { PersonTitle } from '@/modules/common/person/models/PersonResource.model'

@Component({
  components: {
    BaseButton
  }
})
export default class AdminCreateTicketButton extends Vue {
  constructor(
    private readonly ticketCreateUseCase: TicketCreateUseCase
  ) {
    super()
  }

  @Prop({ default: 'جدید' }) label?: string
  @Prop({ default: false }) noLabel?: boolean
  @Prop() ticketPreset!: TicketPresetModel

  private dialog = null
  private ticket: TicketStoreRequestModelInAdmin = {
    department_id: this.ticketPreset?.department_id || null,
    //@ts-ignore
    file: this.ticketPreset?.files || [],
    message: this.ticketPreset?.message || '',
    status: TicketStatus.AGENT_CREATED,
    title: this.ticketPreset?.title || '',
    user_id: this.ticketPreset?.user_id,
    person: this.ticketPreset?.person || PersonTitle.USER
  }

  openDialog() {
    this.dialog = this.$q.dialog({
      component: AdminCreateTicketDialog,
      label: 'ایجاد تیکت جدید',
      isLoading: this.ticketCreateUseCase.isLoading,
      ticket: this.ticket
    }).onOk((request: TicketStoreRequestModelInAdmin) => {
      this.onSubmit(request)
    })
  }

  onSubmit(request) {
    this.dialog.update({ isLoading: true })
    this.ticketCreateUseCase.execute(request)
      .then(() => {
        if (this.ticketCreateUseCase.isSuccess) {
          this.dialog.hide()
        }
        this.dialog.update({ isLoading: false })
      })
  }

}
